<template>
  <div class="videoplayer">
    <div class="video_container">
      <div class="video_aspect"></div>
      <div class="video_box">
        <video
          v-if="id"
          data-account="3326885378001"
          data-player="rkuNCi7ll"
          data-embed="default"
          data-application-id
          ref="videoElement"
          class="video-js intro-video"
          v-bind:data-video-id="id"
          controls
        ></video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: String,
    autoplay: {
      default: false
    }
  },
  data() {
    return {
      videoEl: null
    }
  },
  mounted() {
    this.videoEl = this.$refs.videoElement;
    let player = bc(this.videoEl, { techOrder: ["html5"] });
    player.on("ended", () => {
      this.$emit("ended", this.videoEl.currentTime);
    });
    player.on("play", () => {
      this.$emit("play", this.videoEl.currentTime);
    });
    player.on("seek", () => {
      this.$emit("seek", this.videoEl.currentTime);
    });
    player.on("pause", () => {
      this.$emit("pause", this.videoEl.currentTime);
    });
    player.on("timeupdate", () => {
      this.$emit("timeupdate", this.videoEl.currentTime);
    });
    if (this.autoplay) {
      player.play();
    }
  },
  beforeDestroy() {
    this.$emit("ended", this.videoEl.currentTime);
  }
};
</script>
